/**
 * @description params はデフォルトと同じ形式にする。username に関しては、任意で追加している。
 */
export const AUTH = {
	RESET_PASSWORD_VERIFY: {
		USERNAME: "username",
		VERIFY_CODE: "verify_code",
	},
	INVITATION_VERIFY: {
		USERNAME: "username",
		VERIFY_CODE: "verify_code",
		COMPANY_ID: "companyID",
	},
	SIGN_UP_VERIFY: {
		USERNAME: "username",
		VERIFY_CODE: "verify_code",
	},
} as const;
